import { Grid, Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { JobDetails } from 'quotes/components/QuoteDetails';
import { QuoteEntityType } from 'quotes/enums';
import { IVendorQuote } from 'quotes/types';
import { Level } from 'theme/enums';

import { BillToInfo, MainInfo, QuotedByInfo, ShipToInfo, SoldToInfo } from './Sections';
import { GridWrapper, MultiInfoCardWrapper } from './style';

interface IProps {
  quote: IVendorQuote;
  entityType?: QuoteEntityType;
}

export const VendorQuoteBaseInformation = ({
  quote,
  entityType = QuoteEntityType.QUOTE,
}: IProps) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  // The vendor quote has no local setter (it is read straight from `useGetQuote`), so the job card
  // refreshes by refetching the quote after the rename.
  const updateQuote = () => queryClient.invalidateQueries(['quote']);

  return (
    <GridWrapper container>
      <Typography level={Level.H4}>{t('titleBaseInformation')}</Typography>

      <Grid container md={12} spacing={3}>
        <Grid xs={12} md={6} lg={4}>
          <MainInfo quote={quote} entityType={entityType} />
        </Grid>

        <Grid xs={12} md={6} lg={4}>
          <MultiInfoCardWrapper>
            <SoldToInfo quote={quote} entityType={entityType} />
            <QuotedByInfo quote={quote} />
          </MultiInfoCardWrapper>
        </Grid>

        <Grid xs={12} md={6} lg={4}>
          <MultiInfoCardWrapper>
            <ShipToInfo quote={quote} />
            <BillToInfo quote={quote} />
          </MultiInfoCardWrapper>
        </Grid>

        <Grid xs={12} md={6} lg={4}>
          <JobDetails quote={quote} updateQuote={updateQuote} />
        </Grid>
      </Grid>
    </GridWrapper>
  );
};
